import MaskedInput from 'react-text-mask';
import {React} from 'react';

export const SsnMaskCustom = (props) => {
  const {inputRef, ...other} = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\uFF3F'}
      // showMask
      keepCharPositions={true}
    />
  );
};
